// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import { Toaster } from 'react-hot-toast';
// import App from './App';
// import { Provider } from 'react-redux';
// import Store from './Store/Store';
// import { HelmetProvider } from 'react-helmet-async';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//      <HelmetProvider>
//     <Provider store={Store}>
//     <App />
//     <Toaster position="top-center"
//   reverseOrder={false}/>
//   </Provider>
//   </HelmetProvider>
//   </React.StrictMode>
// );
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import Store from "./Store/Store";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";

// ✅ FULL Bootstrap CSS (REQUIRED)
import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={Store}>
        <App />
        <Toaster position="top-center" reverseOrder={false} />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
